$(function() {
    $('header .show-sub-menu').on('click', function(event) {
        var subMenuClass = $(this).data('sub-menu');

        if (!$('.sub-menu-container.active').hasClass(subMenuClass)) {
            $('header .show-sub-menu.active').removeClass('active');
            $('.sub-menu-container.active').fadeOut(animateSpeed / 2, function() {
                $(this).removeClass('active');
            });
        }

        $(this).toggleClass('active');
        $('.sub-menu-container.' + subMenuClass).fadeToggle(animateSpeed / 2, function() {
            $(this).toggleClass('active');
        });
    });


    $(document).on('click', function(event) {
        if ($('.sub-menu-container').hasClass('active') && !$(event.target).hasClass('sub-menu-container') && !$(event.target).hasClass('show-sub-menu')) {
            $('header .show-sub-menu').removeClass('active');
            $('.sub-menu-container').fadeOut(animateSpeed / 2, function() {
                $(this).removeClass('active');
            });
        }
    });
});